import React from "react";
import EmptyCourseDash from "../../Components/share/EmptyCourseDash/EmptyCourseDash";

function Arbitration() {
  return (
    <div>
      <EmptyCourseDash name="داوری " />
    </div>
  );
}

export default Arbitration;
